import React from 'react'

import Image, { Sizes } from '@/ui/Img/image'

export type Props = {
  group: any
  size?: Sizes
  showAward?: boolean
}

export const ProfileImage = ({
  group,
  size = 'profile-small',
}: Props): React.ReactElement => {
  return (
    <Image
      alt=""
      url={group.image_url || `/images/groups/${group.id}/{image_size}`}
      size={size || 'profile-large'}
      width={size === 'profile-small' ? 30 : size === 'profile-large' ? 85 : 60}
      shape={'circle'}
    />
  )
}

export default ProfileImage
